module.exports = __webpack_public_path__ + "ls.svg?70f84325b9d88b9e3476338919627e91";